import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as firebase from  'firebase';

  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyDNhjY5hz3n9MrEZjmAi74Z2XJuatd3Htk",
    authDomain: "yidi-web.firebaseapp.com",
    databaseURL: "https://yidi-web.firebaseio.com",
    projectId: "yidi-web",
    storageBucket: "yidi-web.appspot.com",
  };
  
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  // firebase.analytics();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
